<template>
    <div class="bg-white relative">
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script setup></script>

<style scoped></style>
